module.exports = __webpack_public_path__ + "img/03.c9a6a437.svg";